
export const setSubNodes = (data) => ({
  type: 'SET_SUBNODES_OF_N-1_SELECTED',
  payload: data
});

export const setTopologyScreen = (data) => ({
  type: 'SET_TOPOLOGY_SCREEN',
  payload: data
});

export const setNetworkIds = (data) => ({
  type: "SET_NETWORK_IDS",
  payload: data
});

const TIME_RANGE_INITIAL_STATE = {
    subNodes:[],
    topologyScreens:[],
    networkIds: []
};

export default function subNodesReducer(state = TIME_RANGE_INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_SUBNODES_OF_N-1_SELECTED':
      return { ...state, subNodes: action.payload };
    case 'SET_TOPOLOGY_SCREEN':
      return { ...state, topologyScreens: action.payload };
    case "SET_NETWORK_IDS":
      return { ...state, networkIds: action.payload };
    default:
      return state;
  }
}